import { Component, Inject } from "@angular/core";

import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { isExecutionResult, isHttpResponseError } from "@tylertech/core-module";

import { MetadataVerification } from "@tylertech/tyler-api-types";

export interface SavingDialogData<T = unknown>
{
    readonly entity: T;
    // eslint-disable-next-line @typescript-eslint/method-signature-style
    readonly onSave: (entity: T) => Promise<T | string>;
}

@Component({
    selector: "saving-dialog-component",
    templateUrl: "./savingDialog.tmpl.html",
    standalone: false
})
export class SavingDialogComponent<T = unknown>
{
    ErrorMessage: string;
    IsError: boolean = false;
    Saving: boolean;
    ValidationMessage: string;

    protected promise: Promise<void>;

    constructor(
        private readonly dialogRef: MatDialogRef<SavingDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private readonly data: SavingDialogData<T>
    )
    {
        this.Saving = true;
        this.save();
    }

    private get entity(): T
    {
        return this.data.entity;
    }

    private get onSave(): (entity: T) => Promise<T | string>
    {
        return this.data.onSave;
    }

    get title(): string
    {
        return this.Saving
            ? "Saving..."
            : this.IsError
                ? "An Error Occurred."
                : "";
    }

    close(): void
    {
        this.dialogRef.close();
    }

    private save(): void
    {
        this.promise = this.onSave(this.entity)
            .then(
                (result: T) =>
                {
                    this.Saving = false;
                    this.IsError = !result;
                    if (result)
                    {
                        this.ValidationMessage = "Save successful";
                        // this.entity = result;
                    }
                    else
                    {
                        // TODO - this is doesn't make sense, if result is falsy, then it is either false, null, undefined, "", or 0.
                        if (typeof result === "string")
                        {
                            this.ErrorMessage = result;
                        }
                        else
                        {
                            this.ErrorMessage = "No records were saved";
                        }
                    }
                },
                (result: unknown) =>
                {
                    this.Saving = false;
                    this.IsError = true;
                    if (!result)
                    {
                        this.ErrorMessage = "No records were saved";
                        return;
                    }

                    if (typeof result === "string")
                    {
                        this.ErrorMessage = result;
                    }

                    if (isHttpResponseError(result))
                    {
                        if (result.error)
                        {
                            if (result.error.AdditionalInfo
                                && (result.error.AdditionalInfo.FieldErrors
                                    || result.error.AdditionalInfo.includes("FieldErrors")))
                            {
                                this.ErrorMessage = result.error.AdditionalInfo.FieldErrors
                                    ? parseMetadataVerification(result.error.AdditionalInfo)
                                    : parseMetadataVerification(JSON.parse(result.error.AdditionalInfo));
                            }
                            else
                            {
                                this.ErrorMessage = result.error.Message;
                            }
                            return;
                        }
                    }

                    if (isExecutionResult(result) && !result.Success)
                    {
                        this.ErrorMessage = result.ErrorMessage;
                    }
                })
            .finally(() =>
            {
                this.promise = undefined;
            });

        function parseMetadataVerification(verificationInfo: MetadataVerification): string
        {
            let errorString = "";
            Object.keys(verificationInfo.FieldErrors)
                .map(k =>
                {
                    return {
                        key: k,
                        value: verificationInfo.FieldErrors[k],
                    };
                })
                .forEach(x =>
                {
                    errorString += x.value.join("\n") + "\n";
                });
            return errorString;
        }
    }
}
